import { render, staticRenderFns } from "./ComplianceDetails.vue?vue&type=template&id=47a6a62c&scoped=true"
import script from "./ComplianceDetails.vue?vue&type=script&lang=js"
export * from "./ComplianceDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDetails.vue?vue&type=style&index=0&id=47a6a62c&prod&lang=css"
import style1 from "./ComplianceDetails.vue?vue&type=style&index=1&id=47a6a62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6a62c",
  null
  
)

export default component.exports